import { render, staticRenderFns } from "./GeneralClassEventsList.vue?vue&type=template&id=49678910&scoped=true"
import script from "./GeneralClassEventsList.vue?vue&type=script&lang=js"
export * from "./GeneralClassEventsList.vue?vue&type=script&lang=js"
import style0 from "./GeneralClassEventsList.vue?vue&type=style&index=0&id=49678910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49678910",
  null
  
)

export default component.exports